<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch color="success" v-model="formCadastro.status" style="width: 60px">
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <!-- Cupom -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Cupom</span>
          <vs-input size="large" class="w-full" name="cupom" id="input-cupom" data-vv-as="'cupom'"
            v-model="formCadastro.cupom" v-validate="'required|min:3'" :state="utilsList.validateState(this.veeFields, this.veeErrors, 'cupom')
              " :danger="!utilsList.validateState(this.veeFields, this.veeErrors, 'cupom')
                " val-icon-danger="clear" danger-text="Preencha este Campo" autocomplete="off"
            @keyup="mascaraCupom($event)" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Valor Credito</span>
          <money class="w-full vs-inputx vs-input--input large" name="Valor Credito" id="Valor Credito"
            v-model="formCadastro.valorCredito" v-validate="{ required: true }" :state="utilsList.validateState(
              this.veeFields,
              this.veeErrors,
              'Valor Credito'
            )
              " :danger="!utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Valor Credito'
              )
                " v-bind="money"></money>
        </div>
      </div>

      <!-- Periodo -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Período</span>
        </div>
        <!-- Data Inicio -->
        <div class="vx-col w-6/12">
          <vs-input size="large" class="w-full" name="dataInicio" data-vv-as="'data de início'"
            v-model="formCadastro.dataInicio" v-validate="'date_format:dd/MM/yyyy|before:dataFinal'" :state="utilsList.validateState(
              this.veeFields,
              this.veeErrors,
              'dataInicio'
            )
              " :danger="!utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'dataInicio'
              )
                " danger-text="Preencha este Campo" val-icon-danger="clear" v-mask="'##/##/####'" icon-pack="feather"
            icon="icon-calendar" icon-no-border autocomplete="off" />
        </div>

        <!-- Data Final -->
        <div class="vx-col w-6/12">
          <vs-input size="large" class="w-full" name="dataFinal" data-vv-as="'data final'" ref="dataFinal"
            v-model="formCadastro.dataFinal" v-validate="'date_format:dd/MM/yyyy'" :state="utilsList.validateState(
              this.veeFields,
              this.veeErrors,
              'dataFinal'
            )
              " :danger="!utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'dataFinal'
              )
                " danger-text="Preencha este Campo" val-icon-danger="clear" v-mask="'##/##/####'" icon-pack="feather"
            icon="icon-calendar" icon-no-border autocomplete="off" />
        </div>
      </div>

      <!-- Quantidade de Utilizacao -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Limite de Utilização</span>
          <vs-input size="large" class="w-full" name="quantidadeUtilizacao" data-vv-as="'limite de utilização'"
            v-model="formCadastro.quantidadeUtilizacao" v-validate="'required'" :state="utilsList.validateState(
              this.veeFields,
              this.veeErrors,
              'quantidadeUtilizacao'
            )
              " :danger="!utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'quantidadeUtilizacao'
              )
                " val-icon-danger="clear" danger-text="Preencha este Campo" autocomplete="off" type="number" />
        </div>
      </div>

      <vs-alert v-if="$validator.errors.all().length > 0" color="danger" title="Atenção!!" active="true" class="my-3"
        style="height: auto !important">
        <ul>
          <li class="mb-2" v-for="error in $validator.errors.all()" :key="error.id">
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button color="warning" type="border" class="mr-3 mb-2" @click.stop.prevent="onReset">Cancelar</vs-button>
          <BotaoSubmit variant="success" :edit="this.dados.idCupom == null ? false : true" :aguarde="aguardeCadastro">
          </BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from "../../../../locale";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import service from "../../../../services";
import BotaoSubmit from "../../../../components/BotaoSubmit";
import dataFunctions from "../../../../utils/dateConversion";
import utilsList from "../../../../utils/list";
import { Money } from "v-money";
import moment from "moment";
export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    contadorRender: {
      type: Number,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
    contadorRender() {
      this.preencheForm();
    },
  },
  data() {
    return {
      utilsList,
      money: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false
      },
      files: new FormData(),
      icone: null,
      activePromptValor: false,
      aguardeCadastro: false,
      valorBeneficio: 0,
      situacoes: ["Ativo", "Inativo"],
      languages: lang,
      funcoesValicao: null,
      formCadastro: {
        idCupom: null,
        cupom: null,
        status: true,
        valorCredito: null,
        dataInicio: null,
        dataFinal: null,
        quantidadeUtilizacao: 1,
      },
    };
  },
  methods: {
    mascaraCupom(event) {
      const input = event.target;
      input.value = input.value.replace(new RegExp(" ", "g"), "");
      input.value = input.value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      input.value = input.value.toUpperCase();
      this.formCadastro.cupom = input.value;
    },
    formataValor(valor) {
      var retorno = this.$options.filters.currency(valor);
      return retorno;
    },
    preencheBeneficio() {
      if (this.beneficio.length == 0) {
        return "";
      } else {
        return this.beneficio.label;
      }
    },
    clearFormGrupo() {
      this.activePromptValor = false;
      this.beneficio = [];
    },
    deletetaTiposBeneficio(idBeneficio) {
      let array = this.TiposBeneficios;
      for (var i = array.length - 1; i >= 0; i--) {
        if (array[i].idBeneficio == idBeneficio) {
          array.splice(i, 1);
        }
      }
    },
    preencheForm() {
      if (this.dados.idCupom) {
        this.formCadastro.idCupom = this.dados.idCupom;
        this.formCadastro.cupom = this.dados.cupom;

        console.log(
          this.dados.dataInicio,
          moment(dataFunctions.converteISOToDate(this.dados.dataInicio)).format(
            "DD/MM/YYYY"
          )
        );
        if (this.dados.dataInicio)
          this.formCadastro.dataInicio = dataFunctions.converteISOToDate(
            this.dados.dataInicio
          );

        if (this.dados.dataFinal)
          this.formCadastro.dataFinal = dataFunctions.converteISOToDate(this.dados.dataFinal);

        this.formCadastro.valorCredito = this.dados.valorCredito
          ? parseFloat(String(this.dados.valorCredito).replace(',', '.').replace(/[^\d.-]/g, ''))
          : 0;
        this.formCadastro.quantidadeUtilizacao = this.dados.quantidadeUtilizacao;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;

      } else {
        this.resetForm();
      }
    },

    onSubmit() {
      var action = "Atualizar/" + this.formCadastro.idCupom;
      var metodo = "put";
      var msgRetorno = "Dados Atualizados com sucesso";
      if (!this.formCadastro.idCupom) {
        action = "Adicionar";
        metodo = "post";
        msgRetorno = "Cupom Adicionado com sucesso";
      }
      var objSend = { ...this.formCadastro };

      console.log(objSend);

      objSend.dataInicio = dataFunctions.convertDateToISO(objSend.dataInicio);

      objSend.dataFinal = dataFunctions.convertDateToISO(objSend.dataFinal);

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service[metodo]("Cupom", action, objSend)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Operação Realizada com sucesso`,
                color: "success",
              });
              this.$emit("concluido");
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list`).then((res) => {
        res.data.forEach((element) => {
          if (element.deletedAt == null)
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
        console.log(this.regionais);
      });
    },
    resetForm() {
      this.TiposBeneficios = [];
      this.formCadastro = {
        idCupom: null,
        cupom: null,
        status: true,
        valorCredito: null,
        dataInicio: null,
        dataFinal: null,
        quantidadeUtilizacao: 1,
      };
    },
    onReset(evt) {
      this.$emit("cancel");

      this.resetForm();
    },
  },
  created() {
    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect,
    Money,
  },
};
</script>
<!------------ END SCRIPT ------------>
